<template lang="pug">
div
	//- .modal-filbox.ss-filbox(dd='provider')
		.modal-filbox-content
			.tt-main Poker
			.filter-close.ss-filbox-close
				img(src='assets/img/cancel-icon.png')
			.conbox
				.tt-item.text-capitalize {{$t('ui.provider')}}
				.filter-itembox.sgfilterbox
					span.sgfilter(:class="{'aaa' : providerSelected === 1 }" @click="changeProvider(1)")
						img(src='assets/img/provider/jili.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 2 }" @click="changeProvider(2)")
						img(src='assets/img/provider/fc-gaming-w.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 0 }" @click="changeProvider(0)")
						img(src='assets/img/provider/pgsoft.png')
	template(v-if="!showMobile")
		topbar
		.conbox
			.hometabs
				tabList
	.tabbox
		.gbox-wrap
			.not-mobile.justify-content-end.mt-2
				.gbox-menu-fav
					template(v-if="isLoggedIn")
						a.sgbtn.s-fav(href='javascript:void(0)' @click="toggleFav")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
							img(v-else src='assets/img/fav-set.png')
					template(v-else)
						a.sgbtn.s-fav(href='javascript:void(0)' @click="openModal()")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
				.gbox-search-box.ss-search-box.aaa
					.search-games
						.iicon
							img(src='assets/img/search-icon.png')
						input.form-control(type='text' v-model="searchinput" placeholder='Search')
			.gbox-menu-wrap-add
				.gbox-menu-fav.only-mobile
					template(v-if="isLoggedIn")
						a.sgbtn.s-fav(href='javascript:void(0)' @click="toggleFav")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
							img(v-else src='assets/img/fav-set.png')
					template(v-else)
						a.sgbtn.s-fav(href='javascript:void(0)' @click="openModal()")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
				.gbox-search.ss-search.only-mobile(@click="toggleSearch")
					.iicon
						img(src='assets/img/search-icon.png')
				.gbox-menu-wrap
					.swiper.gbox-swiper
						.swiper-wrapper
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 1 }" @click="changeProvider(1)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 1 }")
									img.pro-img(src='assets/img/provider/jili.png')
								| Jili
							//- .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 2 }" @click="changeProvider(2)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 2 }")
									img.pro-img(src='assets/img/provider/fc-gaming-w.png')
								| FACHAI
							//- .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 0 }" @click="changeProvider(0)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 0 }")
									img.pro-img(src='assets/img/provider/pgsoft.png')
								| PG Soft
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 3 }" @click="changeProvider(3)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 3 }")
									img.pro-img(src='assets/img/provider/kingmidas.png')
								| KINGMIDAS
			.gbox-search-box.ss-search-box(:class="{'aaa': showSearch}")
				.search-games
					input.form-control(type='text' v-model="searchinput" placeholder='Search')
				span.search-cancel.ss-search-cancel.pointer(@click="cancelSearch") {{$t('ui.cancel')}}
			favList(v-if="showFav" :searchinput="searchinput")
			pg(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
			jili(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
			fc(v-if="providerSelected === 2 && !showFav" :searchinput="searchinput")
			kingmidas(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
			//- yl(v-if="providerSelected === 3")
			//- jdb(v-if="providerSelected === 4")
	footerInfo
</template>
<script>
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import favList from '@/component/table/_favList.vue'
import tabList from '@/views/default/_tabs.vue'
// import pg from '@/component/table/_pg.vue'
import jili from '@/component/table/_jili.vue'
// import fc from '@/component/table/_fc.vue'
import kingmidas from '@/component/table/launchone/_kingmidas.vue'
import footerInfo from '@/views/default/_footer.vue'
// import yl from '@/component/egame/_yl.vue'
// import jdb from '@/component/egame/_jdb.vue'
export default {
	components:{
		topbar,
		tabList,
		favList,
		// pg,
		jili,
		// fc,
		kingmidas,
		footerInfo
		// yl,
		// jdb,
	},
	data(){
		return{
			feedback: {
				success: true,
				status: ""
			},
			loading:false,
			showMobile: false,
			providerSelected: 1,
			imgUrl: config.imageUrl,
			showSearch: false,
			providerList:[
				"PGSOFT",
				"JILI",
				"FACHAI",
			],
			searchinput:"",
			showFav: false
		}
	},
	computed: {
		isLoggedIn(){
			return this.$store.getters.isLoggedIn
		},
		accountID() {
			return this.$store.getters.accountID
		},
		sessionToken() {
			return this.$store.getters.sessionToken
		},
		getProvider(){
			return this.providerList[this.providerSelected]
		},
	},
	created(){
		// this.getSeo("poker")
		this.checkSize()
		var vm = this
		$(window).resize(function () {
			vm.checkSize()
		});
	},
	// metaInfo(){
	// 	if(this.$store.state.user.seoInfo.meta_title && this.$store.state.user.seoInfo.meta_title === "slot"){
	// 		return{
	// 			title: this.$store.state.user.seoInfo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.seoInfo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.seoInfo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.seoInfo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.seoInfo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.seoInfo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.seoInfo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.seoInfo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.seoInfo.meta_image_url},
	// 			]
	// 		}
	// 	}else{
	// 		return{
	// 			title: this.$store.state.user.homeSeo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.homeSeo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.homeSeo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.homeSeo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.homeSeo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.homeSeo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.homeSeo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.homeSeo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.homeSeo.meta_image_url},
	// 			]
	// 		}
	// 	}
		
		
	// },
	mounted(){	
		if(!_.isEmpty(this.$route.params)){
			if(this.$route.params.provider === "00"){
				this.showFav = true
			}else{
				this.providerSelected = this.$route.params.provider
			}
    }
		$(document).on('click', '.ss-filbox-close', function () {
				$(this).closest('.modal-filbox').removeClass('aaa')
				$('body').removeClass('noscroll')
				return false;
		})
		if ($('.gbox-swiper').length) {
			const gboxSwiper = new Swiper('.gbox-swiper', {
				slidesPerView: 2.5,
				spaceBetween: 5,
				navigation: {
					nextEl: '.gbox-swiper-next',
					prevEl: '.gbox-swiper-prev'
				},
				breakpoints: {
					680: {
							slidesPerView: 5.5,
							spaceBetween: 20,
					},
					1280: {
							slidesPerView: 7.5,
							spaceBetween: 20,
					}
				}
			})

		}
	},
	methods:{
		openModal(){
			$("#logModal").modal('show')
		},
		toggleFav(){
			this.showFav = !this.showFav
		},
		toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},	
		showProvider(){
			$('.modal-filbox').addClass('aaa')
			$('body').addClass('noscroll')
		},
		getSeo(page){
			let page_name = page
			this.$store
				.dispatch("user/getSeo", {page_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
		changeProvider(option){
			if(option !== this.providerSelected){
				this.providerSelected = option
			}
			$('.modal-filbox').removeClass('aaa')
			$('body').removeClass('noscroll')
			this.showFav = false
			// if(option === this.providerSelected){
			// 	return
			// }else{
			// 	this.providerSelected = option
			// }
		},
		checkSize(){
			if ($(window).width() < 681) {
				this.showMobile = true
			}else{
				this.showMobile = false
			}
		},
	}
}
</script>